<template>
  <div
    class="message-bubble-row"
    :class="[
      `is-${message.from}`,
      { 'is-alert': alert },
    ]"
  >
    <div v-if="message.from === 'system'" class="message-bubble-row__system">
      {{ message.content }}
    </div>
    <template v-else>
      <z-icon
        v-if="message.from === 'self' && message.read"
        class="message-bubble-row__read"
      >
        <CircleCheck />
      </z-icon>
      <div class="message-bubble" :class="[`is-${message.from}`, { 'is-alert': alert }]">
        <span
          v-if="showSender"
          class="message-bubble__sender"
        >
          {{ message.senderName }}
        </span>
        <z-image
          v-if="message.kind === 'image'"
          class="message-bubble__image"
          :src="message.content"
          :preview-src-list="[message.content]"
          preview-teleported
          fit="cover"
        />
        <p
          v-if="message.kind === 'image' && message.fileName"
          class="message-bubble__caption"
        >
          {{ message.fileName }}
        </p>
        <a
          v-else-if="message.kind === 'file'"
          class="message-bubble__file"
          :href="message.content"
          :download="message.fileName"
          target="_blank"
          rel="noreferrer"
        >
          <z-icon><Document /></z-icon>
          <span>{{ message.fileName || '附件' }}</span>
        </a>
        <div v-else-if="message.kind === 'card'" class="message-bubble__card">
          <p class="message-bubble__card-title">{{ cardTitle }}</p>
          <p class="message-bubble__content">{{ cardBody }}</p>
        </div>
        <p v-else class="message-bubble__content">{{ message.content }}</p>
        <dl v-if="payloadEntries.length && message.kind !== 'card'" class="message-bubble__payload">
          <div v-for="[key, value] in payloadEntries" :key="key">
            <dt>{{ key }}</dt>
            <dd>{{ formatPayloadValue(value) }}</dd>
          </div>
        </dl>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CircleCheck, Document } from '@zoryn/icons'
import ZIcon from '@zoryn/components/icon'
import ZImage from '@zoryn/components/image'
import { formatPayloadValue } from '../utils/message-format'
import type { ChatMessage } from '../types'
import '@zoryn/components/icon/style'
import '@zoryn/components/image/style'

const props = defineProps<{
  message: ChatMessage
  showSender?: boolean
  alert?: boolean
}>()

const payloadEntries = computed(() => {
  const payload = props.message.payload
  if (!payload) return []
  const skip = new Set(['title', 'body', 'level', 'actions', 'refs', 'botCode', 'threadKey'])
  return Object.entries(payload).filter(([key]) => !skip.has(key))
})

const cardTitle = computed(() => {
  const title = props.message.payload?.title
  return typeof title === 'string' ? title : props.message.fileName || ''
})

const cardBody = computed(() => {
  const body = props.message.payload?.body
  return typeof body === 'string' ? body : props.message.content
})
</script>
